import { useContext } from 'react';

import { AuthContext, AuthContextProps } from 'auth/dna';

export const useAuthContext = () => useContext<AuthContextProps>(AuthContext);
